/* Plus+Ultra buy box. Reads tier data rendered by snippets/pu-buybox.liquid and keeps the product form's
   hidden inputs (id, quantity, selling_plan) in sync. Submission is handled by the theme's own product-form.
   The initial state, including a selection carried in by ?variant= / ?selling_plan=, is server-rendered.
   This script re-checks the link as a backup (ids Liquid could not resolve, ?quantity= on one-time links),
   then keeps the inputs in sync as the shopper changes options. */
(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  // Keep "10-in-1" style formula counts on one line in the product title.
  function keepFormulaTogether() {
    document.querySelectorAll('.product-info__title').forEach(function (h) {
      if (h.__puNowrap) return;
      h.__puNowrap = true;
      h.innerHTML = h.innerHTML.replace(/(\d+-in-\d+)/g, '<span class="pu-nowrap">$1</span>');
    });
  }

  function init(root) {
    if (root.__puReady) return;
    root.__puReady = true;
    var tiersEl = root.querySelector('[data-pu-tiers]');
    var cfgEl = root.querySelector('[data-pu-buybox-config]');
    if (!tiersEl || !cfgEl) return;
    var tiers, cfg;
    try {
      tiers = JSON.parse(tiersEl.textContent);
      cfg = JSON.parse(cfgEl.textContent);
    } catch (err) {
      return; // Keep the server-rendered state.
    }
    if (!tiers || !tiers.length) return;
    var fmt = function (c) { return formatMoney(c, cfg.money); };
    var labels = cfg.labels || { subscribe: 'Subscribe & save', oneTime: 'One-time' };

    var idInput = root.querySelector('[data-pu-id]');
    var qtyInput = root.querySelector('[data-pu-qty]');
    var planInput = root.querySelector('[data-pu-plan]');
    var atcLabels = root.querySelectorAll('[data-pu-atc-label]');
    var qtyFieldset = root.querySelector('.pu-buybox__qty');
    var notice = root.querySelector('[data-pu-notice]');

    // The purchasable option for a tier in a mode, or null (not offered or unavailable).
    function option(tier, mode) {
      if (mode === 'subscribe') return tier.sub && tier.sub.ok !== false ? tier.sub : null;
      return tier.ot && tier.ot.ok !== false ? tier.ot : null;
    }
    function otherMode(mode) { return mode === 'subscribe' ? 'one_time' : 'subscribe'; }
    function modeOffered(mode) {
      for (var i = 0; i < tiers.length; i++) if (option(tiers[i], mode)) return true;
      return false;
    }
    function tierFor(q) {
      for (var i = 0; i < tiers.length; i++) if (tiers[i].qty === q) return tiers[i];
      return tiers[0];
    }
    function choice(kind, value) {
      return root.querySelector('[data-pu-' + kind + '-choice][value="' + value + '"]');
    }
    function check(kind, value) {
      var el = choice(kind, value);
      if (el) el.checked = true;
      return !!el;
    }
    function currentQty() {
      var c = root.querySelector('[data-pu-qty-choice]:checked');
      return c ? parseInt(c.value, 10) : cfg.defaultQty;
    }
    function currentMode() {
      var c = root.querySelector('[data-pu-mode-choice]:checked');
      return c ? c.value : 'one_time';
    }
    function setText(sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text;
    }
    function describe(q, mode) {
      return q + ' ' + (q === 1 ? 'bottle' : 'bottles') + ', ' + (mode === 'subscribe' ? labels.subscribe : labels.oneTime);
    }
    function setNotice(text) {
      if (!notice) return;
      notice.textContent = text || '';
      notice.hidden = !text;
    }

    // Show only quantities offered in the current mode. In subscribe mode a one-time bulk price would otherwise sit
    // next to a subscription single-bottle price and buying more would look more expensive.
    function syncPillVisibility(mode) {
      var visible = 0;
      var firstVisible = null;
      var checkedHidden = false;
      tiers.forEach(function (tier) {
        var input = choice('qty', tier.qty);
        if (!input) return;
        var label = input.closest('.pu-pill');
        var hide = !option(tier, mode);
        if (label) label.hidden = hide;
        if (hide && input.checked) checkedHidden = true;
        if (!hide) {
          visible++;
          if (!firstVisible) firstVisible = input;
        }
      });
      if (checkedHidden && firstVisible) firstVisible.checked = true;
      if (qtyFieldset) qtyFieldset.hidden = visible < 2;
    }

    function render() {
      var mode = currentMode();
      if (!modeOffered(mode) && modeOffered(otherMode(mode))) {
        mode = otherMode(mode);
        check('mode', mode);
      }
      syncPillVisibility(mode);
      var q = currentQty();
      var t = tierFor(q);
      if (!option(t, mode) && option(t, otherMode(mode))) {
        mode = otherMode(mode);
        check('mode', mode);
        syncPillVisibility(mode);
      }
      var sub = option(t, 'subscribe');
      var ot = option(t, 'one_time');

      var subRow = root.querySelector('[data-pu-mode-row="subscribe"]');
      var otRow = root.querySelector('[data-pu-mode-row="one_time"]');
      if (subRow) subRow.hidden = !sub;
      if (otRow) otRow.hidden = !ot;

      if (sub) {
        setText('[data-pu-sub-unit]', fmt(sub.unit));
        setText('[data-pu-sub-badge]', sub.pct > 0 ? 'Save ' + sub.pct + '%' : '');
        setText('[data-pu-sub-line]', (sub.cadence || sub.name) + ' · ' + fmt(sub.total) + '\u00a0per\u00a0delivery');
      }
      if (t.ot) {
        setText('[data-pu-ot-unit]', fmt(t.ot.unit));
        setText('[data-pu-ot-badge]', t.ot.pct > 0 ? 'Save ' + t.ot.pct + '%' : '');
        setText('[data-pu-ot-line]', q > 1 ? q + ' bottles · ' + fmt(t.ot.total) + (t.ot.pct > 0 ? ' (discount applied at checkout)' : '') : 'Single bottle, no commitment');
      }

      // Pill prices follow the selected mode: per-bottle price, total, saving chip.
      tiers.forEach(function (tier) {
        var use = (mode === 'subscribe' && option(tier, 'subscribe')) ? tier.sub : tier.ot;
        if (!use) return;
        var price = root.querySelector('[data-pu-pill-price="' + tier.qty + '"]');
        var total = root.querySelector('[data-pu-pill-total="' + tier.qty + '"]');
        var chip = root.querySelector('[data-pu-pill-chip="' + tier.qty + '"]');
        if (price) price.textContent = fmt(use.unit) + (tier.qty > 1 ? '/ea' : '');
        if (total) total.textContent = tier.qty > 1 ? fmt(use.total) + ' total' : '';
        if (chip) chip.textContent = use.pct > 0 ? 'Save ' + use.pct + '%' : '';
      });

      var chosen = option(t, mode);
      root.setAttribute('data-mode', mode);
      if (!chosen) return; // Nothing purchasable: the server rendered a sold-out button.
      idInput.value = chosen.variant;
      qtyInput.value = chosen.quantity;
      if (mode === 'subscribe') {
        planInput.value = chosen.plan;
        planInput.disabled = false;
      } else {
        planInput.value = '';
        planInput.disabled = true;
      }
      atcLabels.forEach(function (l) { l.textContent = cfg.buttonLabel + ' · ' + fmt(chosen.total); });
      setText('[data-pu-sticky-summary]', q + (q === 1 ? ' bottle' : ' bottles') + ' · ' + (mode === 'subscribe' ? 'Subscription · ' + (chosen.cadence || chosen.name) : 'One-time purchase'));
    }

    // Map a link's variant / selling_plan / quantity onto a tier and mode. Returns null when nothing matches.
    function resolveLink(pv, pp, pq) {
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i];
        if (pp) {
          var s = t.sub || t.subUnavailable;
          if (s && String(s.plan) === pp && (!pv || String(s.variant) === pv)) {
            return { tier: t, mode: 'subscribe', ok: !!option(t, 'subscribe') };
          }
        } else if (pv === String(cfg.sellVariant)) {
          if (t.qty === (pq || 1)) return { tier: t, mode: 'one_time', ok: !!option(t, 'one_time') };
        } else if (t.pack && String(t.pack) === pv) {
          return { tier: t, mode: 'one_time', ok: !!option(t, 'one_time') };
        }
      }
      return null;
    }

    // Backup for the server-rendered selection. Liquid resolves ids it recognises; this covers ids it could not
    // (unknown or from another product) and a ?quantity= on a one-time 1-bottle link.
    function applyLink() {
      var params;
      try { params = new URLSearchParams(window.location.search); } catch (err) { return; }
      var pv = (params.get('variant') || '').trim();
      var pp = (params.get('selling_plan') || '').trim();
      if (!pv && !pp) return;
      var pq = parseInt(params.get('quantity') || params.get('qty') || '', 10);
      if (!(pq > 0)) pq = 0;
      var inc = cfg.incoming || {};
      var serverV = inc.variant ? String(inc.variant) : '';
      var serverP = inc.plan ? String(inc.plan) : '';
      var qtyFromLink = !pp && pv === String(cfg.sellVariant) && pq > 1;
      var serverResolved = (!pv || pv === serverV) && (!pp || pp === serverP);
      if (serverResolved && !qtyFromLink) return; // Server-rendered state (and any notice) already reflects the link.

      var r = resolveLink(pv, pp, pq);
      if (r && r.ok) {
        check('qty', r.tier.qty);
        check('mode', r.mode);
        setNotice('');
        return;
      }
      check('qty', cfg.defaultQty);
      check('mode', cfg.defaultMode);
      render();
      var shown = describe(currentQty(), root.getAttribute('data-mode'));
      setNotice(r
        ? describe(r.tier.qty, r.mode) + ' is unavailable right now. Showing ' + shown + ' instead.'
        : "The option in your link isn't available for this product. Showing " + shown + ' instead.');
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-pu-qty-choice], [data-pu-mode-choice]')) {
        setNotice('');
        render();
      }
    });

    // Cart edits keep the selected variant and selling plan together. Check the current line
    // before writing; never remove the old variant before the new one has been accepted.
    var editKey = new URLSearchParams(window.location.search).get('edit_line');
    if (editKey) {
      cfg.buttonLabel = 'Update cart';
      setNotice('Editing your cart item. Choose your supply and purchase option, then update your cart.');
      var back = document.createElement('a');
      back.href = '/cart'; back.className = 'link text-sm'; back.textContent = 'Back to cart';
      notice.insertAdjacentElement('afterend', back);
      var editBusy = false;
      var editButtons = root.querySelectorAll('button[type="submit"]');
      function editLock(locked) { editButtons.forEach(function (button) { button.disabled = locked; }); }
      async function cartRequest(url, payload) {
        var response = await fetch(url, { method: payload ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: payload ? JSON.stringify(payload) : undefined });
        var data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Cart update failed');
        return data;
      }
      root.addEventListener('submit', async function (event) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (editBusy) return;
        editBusy = true; editLock(true); setNotice('Updating your cart…');
        try {
          var cart = await cartRequest('/cart.js');
          var index = cart.items.findIndex(function (item) { return item.key === editKey; });
          if (index < 0) throw new Error('This cart item has changed. Return to your cart to review it.');
          var old = cart.items[index];
          if (String(old.product_id) !== String(cfg.productId) || old.properties && old.properties._byob_group) throw new Error('Please review this item in your cart.');
          var variant = Number(idInput.value), quantity = Number(qtyInput.value), plan = planInput.disabled ? null : Number(planInput.value);
          var result;
          if (Number(old.variant_id) === variant) {
            result = await cartRequest('/cart/change.js', { line: index + 1, quantity: quantity, selling_plan: plan });
          } else {
            var added = { id: variant, quantity: quantity, properties: old.properties || {} };
            if (plan) added.selling_plan = plan;
            await cartRequest('/cart/add.js', { items: [added] });
            // Remove by key so any different lines added in the meantime keep their position and quantity.
            result = await cartRequest('/cart/change.js', { id: old.key, quantity: 0 });
          }
          var present = result.items.some(function (item) { return Number(item.variant_id) === variant && (item.selling_plan_allocation ? Number(item.selling_plan_allocation.selling_plan.id) : null) === plan && item.quantity >= quantity; });
          if (!present) throw new Error('Review the updated cart before continuing.');
          window.location.assign('/cart');
        } catch (error) {
          // A connection failure can happen after Shopify accepted a write. Avoid a second
          // submission that could duplicate it; the cart is the authoritative next step.
          setNotice('We couldn’t confirm the update. Review your cart before trying again. ' + (error.message || ''));
          back.focus();
        }
      }, true);
    }

    applyLink();
    render();
  }

  // Sticky add to cart: visible whenever the main Add to cart button is off screen (above or below).
  function stickyWatch() {
    var atc = document.querySelector('.pu-buybox__atc');
    var bar = document.querySelector('.pu-sticky');
    if (!atc || !bar || bar.__puWatch || !('IntersectionObserver' in window)) return;
    bar.__puWatch = true;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var desktop = window.matchMedia('(min-width:1000px)').matches;
        bar.classList.toggle('pu-sticky--on', !e.isIntersecting && (!desktop || e.boundingClientRect.bottom < 0));
      });
    }).observe(atc);
  }

  // Short description: "Read more" when it is clamped on phones.
  function shortMore() {
    document.querySelectorAll('.pu-short').forEach(function (box) {
      if (box.__puMore) return;
      var p = box.querySelector('p');
      if (!p || p.scrollHeight <= p.clientHeight + 2) return;
      box.__puMore = true;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pu-short__more';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.textContent = open ? 'Show less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      box.appendChild(btn);
    });
  }

  function boot() {
    keepFormulaTogether();
    stickyWatch();
    shortMore();
    document.querySelectorAll('[data-pu-buybox]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
